.breadcrumbs {
  color: var(--tuna-content-secondary);
}

.typeLabel {
  display: inline;
}

.listItemText {
  overflow: hidden;
  padding-right: 32px;
}

.primaryText {
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}

/* Matched words (#2555 M6): a tint behind the text, which keeps its own colour */
.primaryText mark {
  padding: 0 1px;
  color: inherit;
  background: color-mix(in srgb, var(--tuna-feedback-warning) 35%, transparent);
  border-radius: var(--tuna-shape-radius-sm);
}
